import React from 'react';
import './sec4.css'
import Parasec4 from '../components/common/parasec4';
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic28 from '../assets/pic28.png'
import pic29 from '../assets/pic29.png'
import { useState } from 'react';

const Sec4 = () => {

  const [inView, setInView] = useState(false);


  const handleScroll = () => {
    const section = document.querySelector('.sec4');
    if (!section) return;
    const rect = section.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (isVisible !== inView) setInView(isVisible);
  };


window.addEventListener('scroll', handleScroll);
window.addEventListener('load', handleScroll);







    return (  
        <section className='sec4'>
            <article   className={`container-sec4 ${inView ? 'animate' : ''}`} >
                <article className='big-cont-sec4'>
                    <article className='info-cont-sec4'>

                        <article className='left-text-cont-sec4'>
                            <h1 className='header-sec4'>achievements</h1>
                            <Parasec4
                            stylee='para3-sec4'
                             title='One of her key achievements was creating
                              the iconic little black dress in 1926, a design
                               that revolutionized fashion and became a timeless
                                staple cherished for its elegance and
                                 versatility.' />

                            <Parasec4
                            stylee='para-sec4'
                             title='She also introduced the iconic Chanel 
                             suit, known for its tailored jacket and knee-length
                              skirt. In addition, she launched Chanel No. 5 in
                               1921, one of the most famous and best-selling
                                perfumes in the world' />

                        </article>

                        <article className='part2-sec4'>

                            <figure className='imgs-container-sec4'>
                                <img className='pic1-sec4' src={pic26} alt='pic'></img>
                                 <img className='pic2-sec4' src={pic27} alt='pic'></img>
                                 <img  className={`pic3-sec4 ${inView ? 'animate' : ''}`} src={pic28} alt='pic'></img>
                                 <img className='pic4-sec4' src={pic29} alt='pic'></img>
                                 <article className='text-img-sec4'>
                                    <h2  className={`text-sec4-img ${inView ? 'animate' : ''}`}>Key achievements</h2>
                                 </article>
                            </figure>

                            <Parasec4
                            stylee='para2-sec4'
                             title='Chanel also built the global 
                             luxury brand Chanel, which remains highly 
                             influential today. Her designs, including 
                             quilted handbags and costume jewelry, changed 
                             modern fashion and continue to inspire designers
                              around the world.' />


                        </article>



                    </article>
                </article>
            </article>
        </section>
    );
}
 
export default Sec4;